<!--
 * @Author: Merlin
 * @Date: 2023-12-14 13:32:45
 * @LastEditors: Merlin
 * @LastEditTime: 2025-07-24 13:32:42
 * @Description: 
-->
<template>
    <div class="game-container">
        <section v-if="carouselShow == 1 && roTationList.length > 0">
            <Carousel :list="roTationList" />
        </section>
        <!-- 
            ↑ 轮播图
            ↓ 游戏列表 
        -->
        <section
            v-for="(oThis, idx) of aTwoList"
            :key="idx"
            class="game-lists-section"
        >
            <template v-if="oThis?.list?.length">
                <h1 class="big-title">
                    <q-icon
                        :name="oThis.icon.name"
                        :style="{color: oThis.icon.color}"
                    />
                    {{ $t(oThis.i18nTitle) }}
                </h1>
                <ul class="game-lists">
                    <li class="game-lists-item relative"
                        v-for="(item, index) in oThis.list"
                        :key="index"
                        :class="{
                            invisible: oThis.mark == 'popular' && !item.oftenPlayed,
                        }"
                    >
                        <GameCard :data="item" :index="index" />
                        <!-- tag: 0：无  1：hot  2：new -->
                        <!-- status 1: 无， 2: 内测 -->
                        <div :class="item.tag == 0 ? 'justify-end' : 'justify-between'"
                            class="h-[20px] flex items-end text-[10px] font-[600] text-white leading-[12px] pr-[3px] w-[100%] absolute top-0 left-0">
                            <div v-if="item.tag == 1" class="hot flex items-center h-[20px]">
                                <img class="w-[7px] h-[8px] mr-[3px]"
                                    src="@/assets/imgs/fire.png"
                                    v-if="globalStore.innerWidth > 360"
                                    alt="fire"
                                >
                                <span>
                                    {{ $t('gameTitle.Hot') }}
                                </span>
                            </div>
                            <div v-if="item.tag == 2" class="new flex items-center h-[20px] ">
                                <img class="w-[11px] h-[12px] mr-[2px]"
                                    src="@/assets/imgs/star.png" alt=""
                                    v-if="globalStore.innerWidth > 360"
                                >
                                <span>
                                    {{ $t('gameTitle.New') }}
                                </span>
                            </div>
                            <!-- ↓ 右侧的在线人数信息 -->
                            <div class="ml-auto" @click.stop>
                                <ClientOnly>
                                    <Popper hover
                                        :arrow="false"
                                        class="w-full"
                                        :offsetDistance="'0px'"
                                        :offsetSkid="'5px'"
                                        placement="top"
                                        :style="{...oPopperStyle,}"
                                    >
                                        <div
                                            class="flex flex-row flex-nowrap items-center justify-end min-w-[35px] h-[15px] pl-[6px] pr-[6px] online mb-[1px]"
                                        >
                                            <img class="w-[6px] h-[6px] mr-[3px]"
                                                src="@/assets/imgs/signal.png"
                                                alt=""
                                            />
                                            <span class="online-number">
                                                &nbsp;{{ gameOnlineCountInfo[item.id] }}
                                            </span>
                                        </div>
                                        <template #content>
                                            <span class="!text-[10px] font-[400]">
                                                {{ $t('gameTitle.OnlineUsers') }}
                                            </span>
                                        </template>
                                    </Popper>
                                </ClientOnly>
                            </div>
                        </div>
                    </li>
                </ul>
            </template>
        </section>
    </div>
</template>

<script setup lang="ts">
import Popper from "vue3-popper";
import { onMounted, ref } from 'vue';
import { useGameIdListStore } from '~/stores/cansino/gameIdList';
import GameCard from './_components/gameCard.vue';
import Carousel from './_components/carousel.vue';
import { useConfig } from '@/socket/config/index';
import useGlobalStore from '@/stores/global';
import useSettingsStore from '~/stores/settings';
import { useGoldenFlower } from '@/socket/game/goldenFlower';

const globalStore = useGlobalStore();
const settingStore = useSettingsStore();
const currency = storeToRefs(settingStore).pickedCurrency;
const { t: $t } = useI18n();
const { EMIT_GETROTATION, ON_UPDATEGAMEONLINE } = useConfig();
const { EMIT_CHECK_PLAYER_TABLEINFO, EMIT_ZHAJINHUA_FORCE_LEAVE } = useGoldenFlower();
const useGameIdListStores = useGameIdListStore();
const showNoticeDialog = useNoticeDialog();
if (import.meta.server && !useGameIdListStores.gameIdList.length){
    if (import.meta.dev) console.log('查询了首页的游戏列表'); 
    // ↓ 在“服务器一侧” 准备好数据，防止首页高度抖动 
    // ↓ 此操作将为 useGameIdListStores.gameIdList 赋值 
    await useGameIdListStores.initData(990);
}
const dataLists = computed(() => useGameIdListStores.gameIdList);
// 是否开启轮播
const carouselShow = ref(1);
const roTationList = ref([]);
const gameOnlineCountInfo = ref({});
const gameOnlineCountCacheKey = 'gameOnlineCountInfo';
const bannerCacheKey = 'bannerList';

let fnListenerStopper = () => { };

if (import.meta.client && import.meta.env.DEV_MODE){
    dataLists.value.length || console.error('注意，首页游戏列表缺失'); 
}

const aTwoList = computed(()=>{
    const aGameIdList = dataLists.value; 
    let aPopular = aGameIdList.filter(cur=> {
        // 后台返回的 oftenPlayed 是 1，2，3 这样的数据，表示第1常玩的游戏，第2常玩的，第3... 
        // 通常只有3个游戏具备此值 
        return cur.oftenPlayed > 0;
    }).slice(0, 3); 
    // if (!aPopular.length){
    //     // ↓ 找3项替补，防止服务器一侧无数据导致首页高度抖动 
    //     aPopular = aGameIdList.slice(-3);
    // }
    console.log('aPopular', aPopular)
    if (aPopular.length){
        aPopular = deepCopy(aPopular);
        aPopular.sort((aa, bb)=>{
            const iAA = aa.oftenPlayed || 0;
            const iBB = bb.oftenPlayed || 0;
            return iAA - iBB; // 升序 
        });
    }
    const aResult = [{
        mark: 'popular',
        i18nTitle: 'gameTitle.FrequentlyPlaying',
        icon: {
            name: 'sports_esports',
            color: '#FF7F00',
        },
        list: aPopular.slice(0, 3), // 最多显示3个 
    },{
        mark: '',
        i18nTitle: 'gameTitle.PopularGames',
        icon: {
            name: 'whatshot',
            color: '#FB1949',
        },
        list: aGameIdList.filter(cur => {
            // ↓ 防止意外，防止后端返回了超过 3 个的热闹游戏，前端取了前3个
            // ↓ 那么第4个热门游戏被排除了，则应在此被包括进来  
            const inPopular = aPopular.find(item=> {
                return item.id == cur.id;
            }); 
            return !inPopular || !cur.oftenPlayed;
        }),
    }];
    return aResult;
});

// 用于守卫：离开首页后不再弹窗
const isStillOnIndexPage = ref(true);
const checkInfo = async () => {
    await waitUnmount();
    const res = await EMIT_CHECK_PLAYER_TABLEINFO({ currency: currency.value, frontID: new Date().getTime(), });
    // 仅当仍在首页时才弹窗，避免快速切页后在其他页面弹出
    if (!isStillOnIndexPage.value) return;
    if (res.currentTableId) {
        if (!isStillOnIndexPage.value) return;
        const confirm = await showNoticeDialog({
            title: $t('exitGame.tips'),
            mainText: $t(res.tableInfo.status === 'Waiting' ? 'exitGame.inTableZhajinhua' : 'exitGame.gameRunningZhajinhua'),
            mainTextStyle: 'font-size: 12px;font-weight: 600;line-height: 18px;',
            giftIcon: false,
            cancelButtonText: $t('exitGame.forceCanCel'), // 强制退出
            buttonText: $t('exitGame.cancel'),        // 取消（继续游戏）
            themeStyle: 'border-color:#FF7F00;padding:15px 6px 11px 10px;border-width:1px;',
            dogImage: new URL('@/assets/imgs/orange-npc.webp', import.meta.url).href,
            bgImage: new URL('@/assets/imgs/orange-bg.webp', import.meta.url).href,
            oopsImage: new URL('@/assets/imgs/orange-oops.webp', import.meta.url).href,
        });
        const hallCfg = { trial: 1, casual: 2, premium: 3, rick: 4, vip: 5 }
        if (!isStillOnIndexPage.value) return;
        if (confirm) {
            const intOrder = hallCfg[res.currentHall]
            const path = `/casino/zhajinhuaGame/indoor/${intOrder}`;
            useRouter().push({
                path: getLocalPath(path),
                query: {
                    name: res.currentHall,
                },
            });
        } else {
            EMIT_ZHAJINHUA_FORCE_LEAVE({ currency: currency.value, })
        }
    };
}

onMounted(() => {
    checkInfo();
    if (sessionStorage.getItem(bannerCacheKey)) {
        try {
            roTationList.value = JSON.parse(sessionStorage.getItem(bannerCacheKey))
        } catch (error) {

        }
    }
    if (sessionStorage.getItem(gameOnlineCountCacheKey)) {
        try {
            gameOnlineCountInfo.value = JSON.parse(sessionStorage.getItem(gameOnlineCountCacheKey))
        } catch (error) {

        }
    }
    getRoTations()
    fnListenerStopper = getUpdateGameOnLine();
});

// ↓ 在首页时，禁止通过浏览器回退离开首页
onBeforeRouteLeave((to) => {
    if (!import.meta.client) return;
    const isPopstate = !!(window as any).__isPopstateNav;
    const isHistoryBack = !!(window as any).__isHistoryBack;
    if (!isPopstate || !isHistoryBack) return;
    showNegativeNotify({
        type: 'warning',
        i18n: 'commonInfo.noBacking',
    });
    return false;
});

onBeforeUnmount(() => {
    isStillOnIndexPage.value = false;
    fnListenerStopper();
});

// 获取轮播数据
const getRoTations = () => {
    EMIT_GETROTATION({}, (res) => {
        res = (res || {}); 
        res.response = (res.response || []);
        carouselShow.value = res.isopen;
        // ↓ 空数组也需要存起来，用于顶替本地缓存 
        sessionStorage.setItem(bannerCacheKey, JSON.stringify(res.response));
        roTationList.value = res.response;
    });
}

// 获取在线人数
const getUpdateGameOnLine = () => {
    const fnCloser = ON_UPDATEGAMEONLINE((res) => {
        if (!res?.length || !dataLists.value.length) return;
        const _gameOnlineCountInfo = {}
        res.map((i) => {
            _gameOnlineCountInfo[i.id] = i.count
        })
        sessionStorage.setItem(
            gameOnlineCountCacheKey,
            JSON.stringify(_gameOnlineCountInfo),
        );
        gameOnlineCountInfo.value = _gameOnlineCountInfo;
    });
    return fnCloser;
}
</script>

<style lang="scss" scoped>
.game-lists-section{
    .big-title{
        font-weight: 500;
        font-size: 16px;
        line-height: 1.1;
        padding: 15px 0 10px;
        vertical-align: middle;
        .q-icon{
            font-size: 1.3em; 
        }
    }
}


.item {
    font-feature-settings: 'tnum' on, 'lnum' on;
    aspect-ratio: 182/240;
    border-radius: 14px;
    box-shadow: 0 0 0 transparent, 0 0 0 transparent;
    contain-intrinsic-size: 160px 215px;
    content-visibility: auto;
    cursor: pointer;
    height: 100%;
    letter-spacing: -0.02em;
    overflow: hidden;
    text-decoration: none;
    transition: box-shadow 0.1s ease-in-out, transform 0.1s ease-in-out;
    background-size: 100% 100%;
}

.hot {
    padding-left: 7px;
    padding-right: 8px;
    background: linear-gradient(268.96deg, #F34747 0.71%, #C71F1F 99.11%);
    border-radius: 12px 2px 12px 2px;
}

.new {
    padding-left: 6px;
    padding-right: 8px;
    background: linear-gradient(268.96deg, #F98620 0.71%, #FEB041 99.11%);
    border-radius: 12px 2px 12px 2px;
}
.online-number {
    font-size: 20px;
    zoom: 0.5; // 用于在旧浏览器上实现 font-size:10px 
}

.online {
    border-radius: 8px;
    background: #0000004D;
}

.game-container {
    padding: 34px 40px 24px;
    @media (max-width: 995px) {
        margin-top: 19px;
        padding-inline: 16px;
    }
    @media (max-width: 768px) {
        margin-top: 0;
        padding-top: 10px;
        padding-left: 16px;
        padding-right: 16px;
    }
}

.game-lists {
    --column-count: 9!important;
    --gap: 16px;
    --min-width: 160px;
    --single-column-width: calc((100% - (var(--column-count) - 1)*var(--gap))/var(--column-count));
    --wide-column-width: calc((var(--single-column-width) + var(--gap))*2);
    display: grid;
    gap: var(--gap);
    grid-auto-columns: var(--column-width,var(--single-column-width));
    grid-auto-flow: column;
    grid-auto-flow: row;
    grid-template-columns: repeat(var(--column-count),minmax(var(--single-column-width),1fr));
    user-select: none;
    @media (max-width: 1699px) {
        --gap: 16px;
        --column-count: 8!important;
    }
    @media (max-width: 1523px) {
        --column-count: 7!important;
    }
    @media (max-width: 1347px) {
        --column-count: 6!important;
    }
    @media (max-width: 1171px) {
        --column-count: 5!important;
    }
    @media (max-width: 995px) {
        --column-count: 4!important;
        --gap: 12px;
    }
    @media (max-width: 729px) {
        --column-count: 3!important;
    }
    @media (max-width: 555px) {
        --min-width: 100px;
        --column-count: 3!important;
    }
    @media (max-width: 409px) {
        // --column-count: 2!important;
        // 最新要求，每行最少3个游戏 
        --gap: 8px;
        .game-card{
            border-radius: 0;
        }
    }

    @media (max-width: 320px) {
        // --column-count: 2!important;
        // 最新要求，每行最少3个游戏 
        --min-width: 90px;
        --gap: 6px;
    }
    .game-lists-item {
        padding-bottom: 133.6%; // 封面图的宽高比例 1:1.336
        & > .game-card{
            width: 100%;
            height: 100%;
            position: absolute;
            top: 0;
            left: 0;
            right: 0;
            bottom: 0; 
        }
        &:hover {
            position: relative;
            z-index: 10;
        }
    }
}

.left-aside-opened .game-lists {
    @media (max-width: 1931px) {
        --gap: 16px;
        --column-count: 8!important;
    }
    @media (max-width: 1755px) {
        --column-count: 7!important;
    }
    @media (max-width: 1579px) {
        --column-count: 6!important;
    }
}
</style>